import { useEffect, useRef, useCallback } from 'react'

/**
 * Hook per logout automatico dopo inattività
 * 
 * @param {Function} onLogout - Funzione da chiamare al logout
 * @param {number} timeout - Timeout in millisecondi (default 30 minuti)
 */
export function useIdleLogout(onLogout, timeout = 30 * 60 * 1000) {
  const timeoutRef = useRef(null)
  const onLogoutRef = useRef(onLogout)

  // Aggiorna ref
  useEffect(() => {
    onLogoutRef.current = onLogout
  }, [onLogout])

  // Reset timer
  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      console.log('Logout per inattività')
      onLogoutRef.current?.()
    }, timeout)
  }, [timeout])

  useEffect(() => {
    // Eventi che resettano il timer
    const events = [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'click'
    ]

    // Aggiungi listeners
    events.forEach(event => {
      document.addEventListener(event, resetTimer, { passive: true })
    })

    // Avvia timer iniziale
    resetTimer()

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimer)
      })
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [resetTimer])

  return { resetTimer }
}

export default useIdleLogout
